import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles((theme) => ({
  // Marca visual de que o item existe só no formulário — o vínculo ainda não foi gravado.
  pendingChip: {
    height: 22,
    color: theme.palette.warning.dark,
    borderColor: theme.palette.warning.main,
    fontWeight: theme.typography.fontWeightMedium,
    whiteSpace: 'nowrap',
  },
  attachmentItems: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 215,
  },
  // Nome de arquivo sem espaço (ex.: "relatorio_final_v2_revisado.pdf") não quebra sozinho e empurra a
  // linha para fora do card, gerando scroll horizontal. Com `minWidth: 0` o bloco pode encolher dentro do
  // flex e o nome quebra em quantas linhas precisar; os ícones de ação ficam sempre visíveis.
  itemInfo: {
    flex: 1,
    minWidth: 0,
  },
  itemIcon: {
    flexShrink: 0,
  },
  itemName: {
    minWidth: 0,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  itemActions: {
    flexShrink: 0,
  },
  outlinedWarningButton: {
    color: theme.palette.warning.main,
    borderColor: theme.palette.warning.main,
    '&:hover': {
      borderColor: theme.palette.warning.dark,
    },
  },
  containerWarningButton: {
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    },
  },
}))

export default styles
